/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ParentOrderShareRequest { 
    restaurantId?: string;
    restaurantBranchId?: string;
    orderId?: string;
    parentOrderId?: string;
    emailIds?: Array<string>;
    phoneNos?: Array<string>;
    sendBillBySms?: boolean;
    sendBillByEmail?: boolean;
    sendBillByWhatsApp?: boolean;
}